import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, locale = 'fr-FR', currency = 'EUR') {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  }).format(amount);
}

export function formatDate(date, locale = 'fr-FR') {
  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(new Date(date));
}

export function formatDateRelative(date, locale = 'fr-FR') {
  const now = new Date();
  const then = new Date(date);
  
  // Compare dates without time component for accurate day difference
  const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const thenDate = new Date(then.getFullYear(), then.getMonth(), then.getDate());
  const diffDays = Math.floor((nowDate - thenDate) / (1000 * 60 * 60 * 24));
  
  if (diffDays === 0) return locale === 'fr' ? "Aujourd'hui" : 'Today';
  if (diffDays === 1) return locale === 'fr' ? 'Hier' : 'Yesterday';
  if (diffDays < 7) return `${diffDays} ${locale === 'fr' ? 'jours' : 'days'}`;
  
  return formatDate(date, locale);
}

export function calculatePercentage(current, total) {
  if (total === 0) return 0;
  return Math.min(100, Math.round((current / total) * 100));
}

export function getProgressColor(percentage) {
  if (percentage < 50) return 'bg-green-500';
  if (percentage < 80) return 'bg-yellow-500';
  if (percentage < 100) return 'bg-orange-500';
  return 'bg-red-500';
}

export function getCategoryIcon(category) {
  const icons = {
    logement: 'Home',
    transport: 'Car',
    alimentation: 'UtensilsCrossed',
    restaurant: 'UtensilsCrossed',
    abonnements: 'CreditCard',
    shopping: 'ShoppingBag',
    loisirs: 'Gamepad2',
    sante: 'HeartPulse',
    epargne: 'PiggyBank',
    education: 'GraduationCap',
    animaux: 'PawPrint',
    enfants: 'Baby',
    cadeaux: 'Gift',
    entretien: 'Wrench',
    professionnel: 'Briefcase',
    divers: 'CircleDot',
    personnalise: 'Plus',
  };
  return icons[category] || 'CircleDot';
}

export function getCategoryColor(category) {
  const colors = {
    logement: '#FF4F00',
    transport: '#3B82F6',
    alimentation: '#10B981',
    restaurant: '#F97316',
    abonnements: '#8B5CF6',
    shopping: '#EC4899',
    loisirs: '#F59E0B',
    sante: '#EF4444',
    epargne: '#00D68F',
    education: '#6366F1',
    animaux: '#A855F7',
    enfants: '#F472B6',
    cadeaux: '#FB923C',
    entretien: '#78716C',
    professionnel: '#0EA5E9',
    argent_de_poche: '#22D3EE',
    divers: '#A8A29E',
    personnalise: '#CCFF00',
  };
  return colors[category] || '#A8A29E';
}

export function getLevelFromXP(xp) {
  // Simple level calculation: level up every 100 XP
  return Math.floor(xp / 100) + 1;
}

export function getXPForNextLevel(xp) {
  const currentLevel = getLevelFromXP(xp);
  const xpForCurrentLevel = (currentLevel - 1) * 100;
  const xpForNextLevel = currentLevel * 100;
  return {
    current: xp - xpForCurrentLevel,
    required: 100,
    total: xpForNextLevel,
  };
}
